<ng-container *ngIf="render$ | async" />

<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span class="title dialog-title" i18n>Зеркалирование панели</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <div class="flex flex-row space-x-6 justify-center items-center w-full h-full">
        <div class="flex flex-col items-stretch">
          <p class="mat-body-2 panel-note" i18n>Выберите торец</p>
          <csl-svg-workspace
            #svgWorkspaceBefore
            [p]="panel"
            [sideSelectMode]="true"
            (selectSideChange)="selectSide($event)"
            [defaultSelectedSide]="'rc'">
          </csl-svg-workspace>
        </div>

        <div class="flex flex-col items-stretch">
          <p class="mat-body-2 panel-note" i18n>Результат</p>
          <csl-svg-workspace #svgWorkspaceAfter [p]="mirrored"></csl-svg-workspace>
        </div>
      </div>
    </ng-container>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button mat-raised-button class="mat-accent mr-4" (click)="dialogRef.close(mirrored)" i18n>ДОБАВИТЬ ПАНЕЛЬ</button>
    <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
  </div>
</div>
